import { render, staticRenderFns } from "./DashboardLendingByMonthChart.vue?vue&type=template&id=49915cf0"
import script from "./DashboardLendingByMonthChart.vue?vue&type=script&lang=js"
export * from "./DashboardLendingByMonthChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports